import { Dialog } from '@angular/cdk/dialog';
import { type ComponentType } from '@angular/cdk/portal';
import { firstValueFrom, map } from 'rxjs';
import type { DialogConfig, DialogResult } from '@appTypes';

/* Binding del servicio de apertura de diálogos a una función que devuelve la referencia del diálogo y una promesa del cierre */
export const openDialogFn = (dialog: Dialog) =>
  <T, K>(component: ComponentType<unknown>, config?: DialogConfig<T>): DialogResult<K> => {
    const dialogConfig: typeof config & { disableClose: boolean } = { ...config, disableClose: false };
    delete dialogConfig['easyClose'];
    if (config && config.easyClose === false)
      dialogConfig.disableClose = true;
    const dialogRef = dialog.open(component, dialogConfig);
    return {
      dialogRef,
      closed: firstValueFrom(dialogRef.closed.pipe(map(res => res === undefined ? null : res as K))),
    };
  };
